import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getInboundShipmentMetrics } from "./schema/get-inbound-shipment-metrics";
import { getInventoryItems } from "./schema/get-inventory-items";
import { getInventoryMetrics } from "./schema/get-inventory-metrics";
import { getLatestRefulfillmentOrders } from "./schema/get-latest-refulfillment-orders";
import { getManagedReturnsMetrics } from "./schema/get-managed-returns-metrics";
import { getRecentReturns } from "./schema/get-recent-returns";
import { getRefulfillmentMetrics } from "./schema/get-refulfillment-metrics";
import { listInboundConsolidatedShipments } from "./schema/list-inbound-consolidated-shipments";

export const rpcDefinition = {
  getInboundShipmentMetrics,
  getInventoryItems,
  getInventoryMetrics,
  getLatestRefulfillmentOrders,
  getManagedReturnsMetrics,
  getRecentReturns,
  getRefulfillmentMetrics,
  listInboundConsolidatedShipments,
};

export type RedoManagedReturnsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
